export default __webpack_public_path__ + "static/media/2.8dee6fd4.jpeg";